import { toast } from 'react-toastify';
import { GetAuthenticatedDocUrl } from '../redux/documentsSlice';
import { DownloadTaskAttachment } from '../redux/taskSlice';

const triggerBrowserDownload = (url, filename) => {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

/**
 * Download a task attachment for any user who can view it in the task UI.
 * Prefer the attachment file URL (same access as preview); fall back to the download API.
 */
export async function downloadTaskAttachmentFile(dispatch, attachment) {
    if (!attachment?.id) return false;

    const filename = attachment.original_filename || 'download';
    const fileUrl = attachment.file;

    if (fileUrl) {
        try {
            let url = fileUrl;
            if (fileUrl.includes('.blob.core.windows.net')) {
                url = await dispatch(GetAuthenticatedDocUrl(fileUrl)).unwrap();
            }
            triggerBrowserDownload(url, filename);
            return true;
        } catch (err) {
            console.warn('Direct task attachment download failed, trying download endpoint:', err);
        }
    }

    try {
        const result = await dispatch(DownloadTaskAttachment({ attachmentId: attachment.id })).unwrap();
        if (result?.url) {
            triggerBrowserDownload(result.url, result.filename || filename);
            return true;
        }
    } catch (err) {
        console.error('Task attachment download failed:', err);
    }

    toast.error('Download failed. Please try again.', { position: 'top-right' });
    return false;
}
